type Props = {
  label?: string;
  size?: "sm" | "md";
};

export default function Spinner({ label, size = "md" }: Props) {
  const dimension = size === "sm" ? "h-4 w-4" : "h-6 w-6";
  return (
    <span
      className="inline-flex items-center gap-2 text-slate-500"
      role="status"
      aria-live="polite"
    >
      <svg
        className={`${dimension} animate-spin text-emerald-600`}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        />
      </svg>
      {label ? <span className="text-sm">{label}</span> : null}
    </span>
  );
}
